<template>
  <div class="flex grow-0">
    <lf-pill
      v-if="status"
      class="h-6 leading-6 font-semibold uppercase"
      :color-index="colorIndex"
    >
      <icon-base v-if="status === 3" class="mr-1" :icon="IconKnockout" />
      {{ statusName }}
    </lf-pill>
    <div v-else>-</div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import IconKnockout from "@/components/icons/IconKnockout.vue";
import IconBase from "@/components/ui/IconBase.vue";

import type { IApplication } from "@/models/applications";
import type { PropType } from "vue";

const COLOR_CODES = {
  0: 15,
  1: 4,
  2: 0,
  3: 5,
  blank: "",
};

const props = defineProps({
  //Use model, because we have value 0
  model: {
    type: Object as PropType<IApplication>,
    required: true,
  },
});

const store = useStore();

const latestScoreCardStatuses = computed<Record<string, string>>(
  () => store.getters["options/latestScoreCardStatuses"]
);

const status = computed(() => props.model?.score_card_result?.status);

const statusName = computed(() =>
  status.value >= 0 ? latestScoreCardStatuses.value[status.value] : ""
);

const colorIndex = computed(
  () => COLOR_CODES[(status.value as keyof typeof COLOR_CODES) ?? "blank"]
);
</script>
